import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import './Ribbon.css';
import Base from '../Base/Base';

type TypeRibbonType =
  'alert' |
  'inform' |
  'progress' |
  'success' |
  'warning';

export interface Props extends FlexProps {
  /**
   * A callback to remove the ribbon, that when provided will
   * render a clickable cross, that when clicked will call the given
   * function.
   */
  onRemove?: (e: React.SyntheticEvent) => void;
  /**
   * The type of the ribbon that affects the styling.
   */
  type: TypeRibbonType;
}

/**
 * Ribbon component used to inform the user of something system wide important message.
 */
const Ribbon: React.FunctionComponent<Props> = (props: Props) => {
  const {
    children,
    type,
    onRemove,
    ...rest
  } = props;

  const classes = classnames('Ribbon', `Ribbon--type-${type}`);

  return (
    <Flex { ...rest }
        className={ classes }
        direction="horizontal"
        gap="x2"
        paddingHorizontal="x6"
        paddingVertical="x4">
      { onRemove && <Base width="1.5rem"></Base> }
      <Flex grow initial="none">
        { children }
      </Flex>
      { onRemove && (
        <Flex>
          <Link clickable onClick={ onRemove }>
            <Icon name="CloseSmall" size="1.5rem" />
          </Link>
        </Flex>
        ) }
    </Flex>
  );
};

export default Ribbon;
